import { Injectable } from '@angular/core';

// import * as jsts from 'jsts';
import * as jstsIo from 'jsts/org/locationtech/jts/io';
import * as jstsOverlay from 'jsts/org/locationtech/jts/operation/overlay';

import {
	LinearRing,
	LineString,
	MultiLineString,
	MultiPoint,
	MultiPolygon,
	Point,
	Polygon,
} from 'ol/geom';

interface JstsParserExt extends jstsIo.OL3Parser {
	inject?: any;
}
@Injectable({
  providedIn: 'root'
})
export class JstsService {

	constructor() { }

	getJstsParser() {
		const parser: any = new jstsIo.OL3Parser();
		parser.inject(Point, LineString, LinearRing, Polygon, MultiPoint, MultiLineString, MultiPolygon);
		return parser;
	}

	getJstsOverlayOp() {
		// const overlayOp = new jstsOverlay.overlay.OverlayOp();
		const overlayOp = jstsOverlay.OverlayOp;
		return overlayOp;
	}
}
